import React, { useRef } from 'react-x';
import propTypes from 'prop-types-x';
import { CssAnimation } from './CssAnimation.jsx';

export function ErrorMessage(props) {

  const { 
    message,
    displayCondition,
    cssAnimation,
    cssAnimationDelay
  } = props;

  const messageRef = useRef(message); // cache in ref so that when fade out animation trigger is error message text it does nto disappear
  const block = 'c-error-message';

  return (
    <CssAnimation 
    enter={{ name: 'slide-up-fade-in', duration: 0.5, easing: 'ease-out', delay: `${cssAnimationDelay}, hidden` }} 
    exit={{ name: 'fade-out', duration: 0.5, easing: 'ease-out'}}
    triggerEnter={displayCondition} 
    triggerExit={!displayCondition}
    renderView={displayCondition}
    disable={!cssAnimation}
    >
      <div className={block}>{messageRef.current}</div>
    </CssAnimation>
  )
};

ErrorMessage.propTypes = {
  message: propTypes.string,
  cssAnimation: propTypes.bool,
  cssAnimationDelay: propTypes.number
};

ErrorMessage.defaultProps = {
  message: 'An error has occurred.',
  cssAnimation: true,
  cssAnimationDelay: 0
};
